import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { IconButton, ICON_TYPES } from '@st-operations/uikit/src/v2/index'

import './styles.scss'

const CustomAttributeMenuItem = ({ name, className, id, isSelected, onClick, onDelete }) => {
  return (
    <div
      className={classnames('custom-attribute-menu-item', className, {
        'custom-attribute-menu-item--selected': isSelected,
      })}
    >
      <button
        aria-label={`Start editing the ${name} custom attribute`}
        className="custom-attribute-menu-item__button"
        onClick={onClick}
        value={id}
      >
        <span
          className={classnames(
            'custom-attribute-menu-item__value custom-attribute-menu-item__value--bold',
            {
              'custom-attribute-menu-item__value--green': isSelected,
            }
          )}
        >
          {name || '-'}
        </span>
      </button>
      <IconButton
        ariaLabel={`Delete ${name} custom attribute`}
        iconProps={{ icon: 'trashcan', type: ICON_TYPES.OUTLINE, width: '20px', height: '20px' }}
        onClick={() => onDelete(id)}
        classes={{
          icon: 'custom-attribute-menu-item__delete-icon',
          button: 'custom-attribute-menu-item__delete-button',
        }}
      />
    </div>
  )
}

CustomAttributeMenuItem.propTypes = {
  attribute: PropTypes.string,
  className: PropTypes.string,
  isSelected: PropTypes.bool,
  id: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  operator: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.array, PropTypes.number]),
}

CustomAttributeMenuItem.defaultProps = {
  attribute: '',
  className: '',
  isSelected: false,
  onClick: () => {},
  onDelete: () => {},
  operator: '',
  value: '',
}

export default CustomAttributeMenuItem
